<div class="message">
  <div class="header">
    <sd-4-5-1-icon
      color="primary"
      library="{{ iconLibrary }}"
      name="{{ icon || 'content/magnifying-glass' }}"></sd-4-5-1-icon>
    <div class="sd-headline">
      {{ headline || ('fundSearch.noResults.header' | transloco) }}
    </div>
  </div>
  <div class="sd-meta sd-meta--light">
    {{ message || ('fundSearch.noResults.message' | transloco) }}
  </div>
</div>
@if (displayResetButton) {
  <sd-4-5-1-button
    variant="secondary"
    (click)="resetClick.next()"
    size="md">
    {{ 'fundSearch.noResults.resetButton' | transloco }}
  </sd-4-5-1-button>
}
